import css from "./Page404.module.scss";
import React from "react";

export const Page404 = () => {
  return (
    <div className={css.page}>
      <main className={css.page__main}>
        <h1 className={css.page__text}>Страница не найдена</h1>
      </main>
    </div>
  );
};
